import { FiltersButton } from 'common/components/Filters/FiltersButton';

import { useAtom, useSetAtom } from 'jotai';
import {
  chosenIdTypeFilterAtom,
  rsimFiltersAtom,
  searchTextFilterAtom,
} from 'atoms/filters/rsim-products';
import { useResetAtom } from 'jotai/utils';
import { RSimFiltersDialog } from './Components/RSimFiltersDialog';
import { useHasActiveFilters } from './hooks/useHasActiveFilters';
import { useCallback, useState } from 'react';
import { syncHintsAtom, updateHintsAtom } from 'atoms/hints/rsim-products';
import { RSimFiltersDialogAtomInitializator } from './Components/Atoms/RSimFiltersDialogAtomInitializator';
import {
  TableLayoutChips,
  TableLayoutFilters,
  TableLayoutSearchInput,
} from 'common/components/Layouts/TableLayout/TableLayout';
import { RSimFiltersChips } from './Components/Chips/RSimFiltersChips';
import { RSimFilters as RSimFiltersType } from '../constants/rsim';
import { removeNullValuesFromHintsObject } from 'src/common/utils/removeNullValuesFromHintsObject';
import { RSimIdSearchInput } from '../Components/Inputs/RSimIdSearchInput';
import { useDebouncedIdSearch } from 'common/components/Filters/hooks/useDebouncedIdSearch';
import { RSimProductActionToolbar } from 'rSimInventory/Actions/RSimProductActionToolbar.tsx';
import { useIsRSimInLifeChangesAvailable } from 'rSimInventory/Actions/hooks/useIsRSimInLifeChangesAvailable.ts';

export const RSimFilters = () => {
  const [open, setOpen] = useState(false);

  const hasChips = useHasActiveFilters();

  const setFilters = useSetAtom(rsimFiltersAtom);
  const resetFilters = useResetAtom(rsimFiltersAtom);
  const filtersActive = useHasActiveFilters();

  const setHints = useSetAtom(updateHintsAtom);
  const syncHints = useSetAtom(syncHintsAtom);

  const onApply = useCallback((filters: RSimFiltersType) => {
    setFilters(filters);
    setHints(removeNullValuesFromHintsObject(filters));
    setOpen(false);
  }, []);

  const onClose = useCallback(() => {
    setOpen(false);
    syncHints();
  }, []);

  const inlifeChangesEnabled = useIsRSimInLifeChangesAvailable();

  const [chosenId, setChosenId] = useAtom(chosenIdTypeFilterAtom);
  const { inputValue, onChange, stopDebouncing } = useDebouncedIdSearch({
    searchTextFilterAtom,
  });

  return (
    <>
      <TableLayoutFilters showBorder>
        <TableLayoutSearchInput>
          <RSimIdSearchInput
            chosenId={chosenId}
            onChosenIdChange={setChosenId}
            search={inputValue}
            onSearchChange={onChange}
          />
        </TableLayoutSearchInput>
        <FiltersButton
          onClick={() => {
            stopDebouncing();
            setOpen(true);
          }}
          active={filtersActive}
        />
        {open && (
          <RSimFiltersDialogAtomInitializator>
            <RSimFiltersDialog
              onApply={onApply}
              onCancel={onClose}
              onClear={resetFilters}
              onClose={onClose}
            />
          </RSimFiltersDialogAtomInitializator>
        )}
        {inlifeChangesEnabled && <RSimProductActionToolbar />}
      </TableLayoutFilters>
      <TableLayoutChips hide={!hasChips} showBorder>
        <RSimFiltersChips />
      </TableLayoutChips>
    </>
  );
};
